module.exports = __webpack_public_path__ + "static/final_project-7ec0b017ec4644a210ca56a186800420.gif";